import React from "react";
import { Typography } from "antd";
import CompanyDetails from "../trom/CompanyDetails";
import PatientDetails from "../trom/PatientDetails";
import Plan from "../trom/Plan";
import ServiceDetails from "../trom/ServiceDetails";
import EmployeeDetails from "../trom/EmployeeDetails";
import TromWrapper from "../trom/TromWrapper.style";

const { Title } = Typography;

const StartOfTrom = (props) => {
  const { record } = props;
  return (
    <TromWrapper>
      <div id="start_of_trom" className="pdf" dir="rtl">
        <CompanyDetails />
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "0",
          }}
        >
          הודעה על שירותי טרום סיעוד
        </Title>
        <div className="verticalSeperator" />
        <PatientDetails startOfTrom={true} />
        <div className="verticalSeperator" />
        <ServiceDetails startOfTrom={true} record={record} />
        <div className="verticalSeperator" />
        <Plan record={record} />
        <div className="verticalSeperator" />
        <EmployeeDetails record={record} />
        <div />
      </div>
    </TromWrapper>
  );
};

export default StartOfTrom;
